/** @format */

import { Layout } from "../../components/common/Layout";
import ShowNowWithoutAuth from "../../components/ShopNow/ShowNowWithoutAuth";

export default function ShowNowWithoutAuthPage() {
  const meta = {
    title:
    "Global sourcing from India | Verified suppliers from India | Ready to ship inventory -- Qalara",

      // "Qalara | Global sourcing & wholesale | UK Europe Australia Canada USA",
    description: "Source Qalara’s curated collection of lifestyle products with low MOQs, ready-to-ship availability, and made-to-order flexibility. Explore trend-driven picks, custom production, and sourcing tailored to your business needs.",
      //"Global wholesale platform for sourcing artisanal & sustainable lifestyle goods - Décor, Rugs ,Carpets, Kitchen, Fashion, Kids, Toys, Cushions, Home linen, vases",
    keywords:
      "Offers,  values, categories, wholesale, bulk, ready-to-ship, custom, fashion, accessories, homedecor, furniture, rugs, kitchen, dining, linen, furnishings, artisanal, organic, sustainable, ecofriendly India, Southeast asia, bamboo, copper, jute, linen, global, exports, imports, vendors, suppliers, wholesale buying India, furniture exporters from india, cottage decor wholesale, wholesale outdoor furniture suppliers, fair trade baskets, eco friendly rugs, handmade coffee mugs, wholesale farmhouse decor",
    url: "/explore/shopnow-guest/",
  };

  return (
    <Layout meta={meta}>
       <section style={{ display: "none" }}>
        <h1>Source our full range of ready to ship, customizable & made-to-order</h1>
        <h2>From small orders to scalable solutions</h2>
        <h3>Low minimums, fast delivery & global sourcing power</h3>
        <h4>Redefining B2B sourcing for home & lifestyle brands</h4>
        <h5>Stay ahead with trend-based picks & curated collections</h5>
        <h6>Need customization? We’ve got you covered with flexible MOQs & production options</h6>
      </section>
      <ShowNowWithoutAuth />
    </Layout>
  );
}
